const translations = {
    en: {
        shared: {
            best_friend: {
                ask_me_anything: "...ask me anything, anytime. Let's chat together...",
                fb_chat_button: "Chat with me!",
                whatsapp_chat_button: "Chat with me!"
            }
        }
    },
    de: {
        shared: {
            best_friend: {
                ask_me_anything: "...frag einfach nach mir, jederzeit...",
                fb_chat_button: "Chat mit mir!",
                whatsapp_chat_button: "Chat mit mir!"
            }
        }
    },
    es: {
        shared: {
            best_friend: {
                ask_me_anything: "...Preguntenme lo que quiera, cuando usted quiera...",
                fb_chat_button: "Chatee conmigo!",
                whatsapp_chat_button: "Chatee conmigo!"
            }
        }
    },
    fr: {
        shared: {
            best_friend: {
                ask_me_anything: "...demandez-moi n'importe quoi, n'importe quand...",
                fb_chat_button: "Chattez avec moi!",
                whatsapp_chat_button: "Chattez avec moi!"
            }
        }
    },
    it: {
        shared: {
            best_friend: {
                ask_me_anything: "...chiedimi quello che vuoi, quando vuoi...",
                fb_chat_button: "Chatta con me!",
                whatsapp_chat_button: "Chatta con me!"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/shared/BestFriend.js